// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"114":"56cdc9b9","161":"72ff1665","239":"e7a2ff17","241":"843f670e","355":"72307071","396":"c895db99","455":"5dc4d069","673":"24d0f32e","715":"d8a30746","722":"c4662f89","857":"44e4468d","882":"f1d0dbb6","889":"68fec9fa","977":"a723575a"}[chunkId] + ".chunk.js";
};